module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "newStockCheck"
    }
  }, [_c('el-row', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-col', {
    staticClass: "fl",
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.backGo()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    attrs: {
      "span": 1
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fl searthPart"
  }, [_c('el-form', {
    ref: "returnForm",
    attrs: {
      "model": _vm.returnForm,
      "inline": true,
      "label-width": "80px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "盘点类型"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择盘点类型",
      "clearable": ""
    },
    on: {
      "change": _vm.getPicking
    },
    model: {
      value: (_vm.returnForm.verificationType),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "verificationType", $$v)
      },
      expression: "returnForm.verificationType"
    }
  }, _vm._l((_vm.pickingTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.returnForm.verificationType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "盘点仓库"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择盘点仓库",
      "clearable": ""
    },
    model: {
      value: (_vm.returnForm.inventoryType),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "inventoryType", $$v)
      },
      expression: "returnForm.inventoryType"
    }
  }, _vm._l((_vm.pickingList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraCode
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin-right": "15%",
      "margin-top": "10px"
    },
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportStock()
      }
    }
  }, [_vm._v("导入库存信息")])], 1) : _vm._e(), _vm._v(" "), (_vm.returnForm.verificationType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "盘点工程师"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择盘点工程师",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.returnForm.inventoryType),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "inventoryType", $$v)
      },
      expression: "returnForm.inventoryType"
    }
  }, _vm._l((_vm.pickingEngineerList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin-right": "15%",
      "margin-top": "10px"
    },
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportStock()
      }
    }
  }, [_vm._v("导入库存信息")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "盘点备注"
    }
  }, [_c('el-input', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "clearable": "",
      "type": "textarea",
      "placeholder": "请输入备注信息"
    },
    model: {
      value: (_vm.returnForm.memo),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "memo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "returnForm.memo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      },
      "summary-method": _vm.getSummaries,
      "show-summary": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "index",
      "width": "50",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "status",
      "label": "盘点状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('span', [_vm._v("待盘点")]) : _c('span', [_vm._v("已盘点")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "inventoryQuantity",
      "label": "库存数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "verificationQuantity",
      "label": "盘点数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "profitLoss",
      "width": "160",
      "label": "盘点损益差(单位：%)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.addSerial(scope.row, scope.$index)
            }
          }
        }, [_vm._v("扫描盘点")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50 ],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加序列号",
      "visible": _vm.dislogSerial,
      "close-on-click-modal": false,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogSerial = $event
      },
      "close": function($event) {
        return _vm.cancelSerial()
      }
    }
  }, [_c('el-row', [_c('el-col', [(_vm.dislogSerial) ? _c('el-form', {
    ref: "materialParams",
    attrs: {
      "model": _vm.materialParams
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "clearable": "",
      "autofocus": _vm.dislogSerial,
      "placeholder": "请输入或扫描序列号"
    },
    on: {
      "input": _vm.queryBySerialNumberData
    },
    model: {
      value: (_vm.materialParams.number),
      callback: function($$v) {
        _vm.$set(_vm.materialParams, "number", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "materialParams.number"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('span', {
    staticClass: "scanTitle"
  }, [_vm._v("扫描记录")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "border": "1px solid #EBEEF5",
      "border-bottom": "none"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.codeList,
      "border": false,
      "height": "465",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "index",
      "width": "50",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "code",
      "label": "序列号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteCode(scope.$index, _vm.codeList)
            }
          }
        }, [_vm._v("移除")])]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.addSerialComformBtn()
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.cancelSerial()
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.DetermineSave()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "split-button": "",
      "type": "primary",
      "trigger": "click"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pageStatus) + "\n            "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.goOnSave()
      }
    }
  }, [_vm._v("留在当前页面")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeSave()
      }
    }
  }, [_vm._v("离开当前页面")])], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelOrder()
      }
    }
  }, [_vm._v("取消新建")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-0acf91f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/storehouseManage/newStockCheck.vue
// module id = 1576
// module chunks = 0